import {
  CopyTradeLeader,
  CopyTradeLeaderDetail,
  CopyTradeLeaderPositionsPayload,
  CopyTradeLeaderSnapshot,
  CopyTradeMirroredPositionView,
  CopyTradeSubscription,
  CreateCopyTradeSubscriptionPayload,
  UpdateCopyTradeSubscriptionPayload,
} from "@crypto-trading/common/browser";
import { ApiClientManager } from "@/utils/api-client-factory";

export const listCopyTradeLeaders = async (
  source = "binance"
): Promise<CopyTradeLeader[]> => {
  return ApiClientManager.getCopyTradeClient().listLeaders(source);
};

export const getCopyTradeLeaderDetail = async (
  portfolioId: string,
  source = "binance"
) => {
  return ApiClientManager.getCopyTradeClient().getLeaderDetail(
    portfolioId,
    source
  );
};

export const getCopyTradeLeaderPositions = async (
  portfolioId: string,
  source = "binance"
): Promise<CopyTradeLeaderPositionsPayload> => {
  return ApiClientManager.getCopyTradeClient().getLeaderPositions(
    portfolioId,
    source
  );
};

export const listCopyTradeSubscriptions = async (
  userId: string
): Promise<CopyTradeSubscription[]> => {
  if (!userId) return [];
  return ApiClientManager.getCopyTradeClient().listSubscriptions(userId);
};

export const listCopyTradeMirroredPositions = async (
  subscriptionId: string,
  userId: string
): Promise<CopyTradeMirroredPositionView[]> => {
  if (!subscriptionId || !userId) return [];
  return ApiClientManager.getCopyTradeClient().listMirroredPositions(
    subscriptionId,
    userId
  );
};

export const subscribeToCopyTradeLeader = async (
  userId: string,
  payload: CreateCopyTradeSubscriptionPayload
): Promise<CopyTradeSubscription> => {
  return ApiClientManager.getCopyTradeClient().subscribe(userId, payload);
};

export const updateCopyTradeSubscription = async (
  subscriptionId: string,
  userId: string,
  payload: UpdateCopyTradeSubscriptionPayload
): Promise<CopyTradeSubscription> => {
  return ApiClientManager.getCopyTradeClient().updateSubscription(
    subscriptionId,
    userId,
    payload
  );
};

export const unsubscribeFromCopyTrade = async (
  subscriptionId: string,
  userId: string
): Promise<void> => {
  return ApiClientManager.getCopyTradeClient().unsubscribe(
    subscriptionId,
    userId
  );
};

export function getBinanceLeadDetailsUrl(leadPortfolioId: string): string {
  return `https://www.binance.com/en/copy-trading/lead-details/${leadPortfolioId}?timeRange=30D`;
}

export type {
  CopyTradeLeader,
  CopyTradeLeaderDetail,
  CopyTradeLeaderPositionsPayload,
  CopyTradeLeaderSnapshot,
  CopyTradeMirroredPositionView,
  CopyTradeSubscription,
};
